import { PdfGrid,PdfPen,PdfBitmap, PdfDocument, PdfBorders,PdfPage ,PdfColor,PdfSolidBrush,PdfFontStyle,PdfPageSize,PdfPageOrientation, PdfAlignmentStyle, PdfStringFormat, PdfTextAlignment,PdfStandardFont , PdfFontFamily} from "@syncfusion/ej2-pdf-export";
// import { PdfDocument, PdfBitmap, PdfPageSize } from '@syncfusion/pdf-export';



const imagePDF = async (type = 'download') => {
    console.log(type);

    // Create a new PDF document
    const document = new PdfDocument();

    // Set page settings
    document.pageSettings.margins.all = 10;
    document.pageSettings.margins.bottom = 5;
    document.pageSettings.size = PdfPageSize.a4;

    // Define header font and brush
    const headerFont = new PdfStandardFont(PdfFontFamily.Helvetica, 18);
    const blackBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));

    // Add a new page to the document
    const page = document.pages.add();
    const graphics = page.graphics;

    try {
        // Load the image as a blob
        const response = await fetch('https://picsum.photos/536/354', { mode: 'cors' }); 
        if (!response.ok) {
            throw new Error(`Failed to fetch image: ${response.statusText}`);
        }

        const imageBlob = await response.blob();
        console.log(imageBlob)
        // Convert Blob to Base64
        const imageBase64 = await blobToBase64(imageBlob);

        // Create a PdfBitmap from the Base64 image
        const image = new PdfBitmap(imageBase64);
        // Draw the image on the PDF
        graphics.drawImage(image, 10, 10, 50, 50); // Adjust x, y, width, height as needed
        addPageNumbers(document)
        if (type === 'save') {
            const pdfBlob = await document.save();

            // Destroy the document to release resources
            document.destroy();

            return pdfBlob;
        } else {
            // Save the PDF document to a file
            document.save("ImagePDF.pdf");

            // Destroy the document to release resources
            document.destroy();
        }
    } catch (error) {
        console.error("Error loading image:", error);
    }
};
const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extract only Base64 data
      reader.onerror = reject;
      reader.readAsDataURL(blob);
  });
};

const addPageNumbers = (document) => {
    const totalPages = document.pages.count;
    console.log(totalPages)
    const font = new PdfStandardFont(PdfFontFamily.Helvetica, 10);
  
    for (let i = 0; i < totalPages; i++) {
      console.log( document.pages.getPage(i))
      const page = document.pages.getPage(i); // Correct way to access a page
      if (!page) continue; // Skip if page doesn't exist

  
        const graphics = page.graphics;
        
        // Create the page number text
        const pageNumberText = `Page ${i + 1} of ${totalPages}`;
        console.log(pageNumberText)
        // Set position for bottom-right corner
        const xPos = page.size.width - 80;  // Adjust spacing from right edge
        const yPos = page.size.height - 30;  // Adjust spacing from bottom edge
  
        graphics.drawString(pageNumberText, font, null, new PdfSolidBrush(new PdfColor(0, 0, 0)), xPos, yPos);
    }
  };

export default imagePDF